// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hall groups — each squad is a court lane painted in the club colours. */
.gl-board {
  --gl-pine: var(--brand-primary, #0877bc);
  --gl-tape: color-mix(in srgb, #fff 88%, var(--brand-primary, #0877bc));
  --gl-clay: var(--brand-secondary, var(--brand-primary-dark, #0a5a8a));
  --gl-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));
  --gl-slate: color-mix(in srgb, var(--brand-primary, #0877bc) 42%, #1e293b);
  --gl-lagoon: color-mix(in srgb, var(--brand-secondary, var(--brand-primary, #0877bc)) 72%, #0f766e);
  --gl-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --gl-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --gl-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;

  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding:
    max(0.85rem, env(safe-area-inset-top, 0px))
    max(1.15rem, env(safe-area-inset-right, 0px))
    calc(2rem + env(safe-area-inset-bottom, 0px))
    max(1.15rem, env(safe-area-inset-left, 0px));
  overflow-x: clip;
  overflow-y: auto;
  max-height: calc(100vh - 64px);
  color: var(--text-color);
  font-family: var(--gl-body);
}

.gl-board--embedded {
  padding: 0 0.25rem 0.5rem;
  max-height: none;
  overflow: visible;
}

.gl-board *,
.gl-board *::before,
.gl-board *::after {
  box-sizing: border-box;
}

.gl-board .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.gl-board__glow {
  pointer-events: none;
  position: absolute;
  z-index: -1;
  inset: -8% -18% auto;
  height: 180px;
  opacity: 0.7;
  background:
    radial-gradient(52% 70% at 8% 18%, color-mix(in srgb, var(--gl-pine) 18%, transparent) 0%, transparent 72%),
    radial-gradient(40% 55% at 92% 0%, color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent) 0%, transparent 68%);
}

.gl-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem 1.25rem;
  margin-bottom: 1.15rem;
}

.gl-hero__copy {
  min-width: 0;
  max-width: 40rem;
}

.gl-hero__club {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0 0 0.4rem;
}

.gl-hero__club img {
  width: auto;
  max-width: 36px;
  max-height: 40px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.gl-hero__kicker {
  display: block;
  margin: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.gl-hero__title {
  margin: 0;
  font-family: var(--gl-display);
  font-size: clamp(2rem, 4.2vw, 2.85rem);
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 0.95;
  text-transform: uppercase;
  color: var(--text-color);
}

.gl-hero__lede {
  margin: 0.45rem 0 0;
  max-width: 34rem;
  font-size: 0.95rem;
  line-height: 1.45;
  color: var(--text-secondary, #64748b);
}

.gl-hero__add {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
  padding: 0.7rem 1.05rem;
  border-radius: 999px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-family: var(--gl-body);
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-decoration: none;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
  transition: transform 0.18s var(--gl-ease), box-shadow 0.18s var(--gl-ease);
}

.gl-hero__add:hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px color-mix(in srgb, var(--brand-primary, #0877bc) 36%, transparent);
}

.gl-hero__add:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
}

.gl-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem;
  margin-bottom: 1.1rem;
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 0.35rem 0 0.55rem;
  background: color-mix(in srgb, var(--bg-color, #f7f8f6) 88%, transparent);
  backdrop-filter: blur(10px);
}

.gl-toolbar__hint {
  flex: 1 1 100%;
  margin: -0.15rem 0 0;
  color: var(--text-secondary, #64748b);
  font-size: 0.75rem;
}

.gl-search {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex: 1 1 16rem;
  min-width: 0;
  padding: 0.55rem 0.85rem;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.12));
  background: var(--surface-color, #fff);
  color: var(--text-secondary, #64748b);
}

.gl-search:focus-within {
  border-color: var(--brand-primary, #0877bc);
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
  color: var(--text-color);
}

.gl-search input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-color);
  font-family: inherit;
  font-size: 0.92rem;
}

.gl-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.gl-pill {
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
  padding: 0.38rem 0.7rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--gl-pine) 10%, var(--surface-color, #fff));
  color: var(--text-color);
  font-size: 0.78rem;
  font-weight: 500;
}

.gl-pill strong {
  font-variant-numeric: tabular-nums;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.gl-lanes {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.gl-lane {
  --lane: var(--gl-pine);
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto auto;
  align-items: stretch;
  gap: 0;
  border-radius: 18px;
  border: 1px solid color-mix(in srgb, var(--lane) 22%, var(--border-color, rgba(15, 23, 42, 0.1)));
  background: var(--surface-color, #fff);
  overflow: hidden;
  box-shadow: 0 12px 32px color-mix(in srgb, var(--lane) 10%, transparent);
  transition: transform 0.2s var(--gl-ease), box-shadow 0.2s var(--gl-ease);
}

@media (prefers-reduced-motion: no-preference) {
  .gl-lane:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 36px color-mix(in srgb, var(--lane) 16%, transparent);
  }
}

.gl-lane--pine { --lane: var(--gl-pine); }
.gl-lane--ink { --lane: var(--gl-ink); }
.gl-lane--clay { --lane: var(--gl-clay); }
.gl-lane--slate { --lane: var(--gl-slate); }
.gl-lane--lagoon { --lane: var(--gl-lagoon); }

.gl-lane__tape {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: var(--lane);
  box-shadow: inset -1px 0 0 color-mix(in srgb, #fff 16%, transparent);
}

.gl-lane__no {
  font-family: var(--gl-display);
  font-size: 1.55rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  line-height: 1;
  color: var(--gl-tape);
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-shadow: 0 1px 0 color-mix(in srgb, #000 28%, transparent);
}

.gl-lane__main {
  min-width: 0;
  padding: 0.95rem 0.5rem 0.95rem 1rem;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  font: inherit;
  cursor: default;
}

.gl-lane__main.is-open {
  cursor: pointer;
}

.gl-lane__main.is-open:hover {
  background: color-mix(in srgb, var(--lane) 6%, transparent);
}

.gl-lane__main:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: -2px;
}

.gl-lane__who {
  min-width: 0;
}

.gl-lane__name-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.45rem 0.7rem;
}

.gl-lane__name {
  margin: 0;
  font-family: var(--gl-display);
  font-size: clamp(1.35rem, 2.4vw, 1.7rem);
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
  color: var(--text-color);
}

.gl-lane__mode {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.48rem;
  border-radius: 4px;
  border: 1px solid color-mix(in srgb, var(--lane) 35%, transparent);
  background: color-mix(in srgb, var(--lane) 9%, transparent);
  color: var(--lane);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.gl-lane__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.85rem;
  margin-top: 0.5rem;
  color: var(--text-secondary, #64748b);
  font-size: 0.8rem;
}

.gl-lane__meta span {
  display: inline-flex;
  align-items: baseline;
  gap: 0.28rem;
}

.gl-lane__meta strong {
  font-variant-numeric: tabular-nums;
  font-weight: 650;
  color: var(--text-color);
}

.gl-occupancy {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin: 0.55rem 0.15rem;
  padding: 0.35rem 0.55rem;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: inherit;
  font-family: var(--gl-body);
  font-size: inherit;
  cursor: pointer;
}

.gl-occupancy:hover {
  background: color-mix(in srgb, var(--lane) 8%, transparent);
}

.gl-occupancy:hover .gl-occupancy__n {
  color: var(--brand-primary, #0877bc);
}

.gl-occupancy:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.gl-court {
  position: relative;
  width: 124px;
  height: 70px;
  flex-shrink: 0;
  margin: 6px 0;
  border-radius: 3px;
  border: 2.5px solid color-mix(in srgb, #f4f7f2 82%, var(--text-color));
  background: var(--gl-pine);
  overflow: visible;
  box-shadow:
    inset 0 0 0 1px color-mix(in srgb, #fff 22%, transparent),
    0 6px 14px color-mix(in srgb, var(--gl-pine) 28%, transparent);
}

.gl-court__surface {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, color-mix(in srgb, #0b1f18 22%, transparent), transparent 18% 82%, color-mix(in srgb, #0b1f18 22%, transparent)),
    var(--gl-pine);
}

.gl-court__net {
  position: absolute;
  left: 50%;
  top: 2px;
  bottom: 2px;
  width: 3px;
  transform: translateX(-50%);
  background: repeating-linear-gradient(
    180deg,
    #f8faf8 0 3px,
    transparent 3px 6px
  );
  opacity: 0.92;
}

.gl-court__mid {
  position: absolute;
  left: 7px;
  right: 7px;
  top: 50%;
  height: 1.5px;
  background: color-mix(in srgb, #fff 68%, transparent);
}

.gl-seat {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: color-mix(in srgb, #fff 22%, transparent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, #fff 18%, transparent);
}

.gl-seat.is-on {
  background: #f3efe4;
  box-shadow: 0 0 0 1px color-mix(in srgb, #1a1208 35%, transparent);
}

.gl-seat--0 { left: 14%; top: 4px; }
.gl-seat--1 { left: 34%; top: 4px; }
.gl-seat--2 { left: 54%; top: 4px; }
.gl-seat--3 { left: 74%; top: 4px; }
.gl-seat--4 { left: 14%; bottom: 4px; }
.gl-seat--5 { left: 34%; bottom: 4px; }
.gl-seat--6 { left: 54%; bottom: 4px; }
.gl-seat--7 { left: 74%; bottom: 4px; }

.gl-occupancy__stat {
  display: flex;
  flex-direction: column;
  min-width: 4.5rem;
}

.gl-occupancy__n {
  font-variant-numeric: tabular-nums;
  font-size: 1.45rem;
  font-weight: 650;
  letter-spacing: -0.04em;
  line-height: 1;
  color: var(--text-color);
}

.gl-occupancy__label {
  margin-top: 0.15rem;
  color: var(--text-secondary, #64748b);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.gl-lane__actions {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.65rem 0.7rem 0.65rem 0;
  background: transparent;
}

.gl-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--text-secondary, #64748b);
  cursor: pointer;
  transition: background 0.15s var(--gl-ease), color 0.15s var(--gl-ease);
}

.gl-icon:hover {
  background: color-mix(in srgb, var(--text-color) 7%, transparent);
  color: var(--text-color);
}

.gl-icon--danger:hover {
  background: color-mix(in srgb, #dc2626 12%, transparent);
  color: #dc2626;
}

.gl-icon:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.gl-empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1.6rem 1.2rem 1.5rem;
  border-radius: 16px;
  border: 1px dashed color-mix(in srgb, var(--gl-pine) 35%, var(--border-color, #d1d5db));
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--gl-pine) 6%, transparent), transparent 48%),
    var(--surface-color, #fff);
}

.gl-empty__court {
  width: 88px;
  height: 50px;
}

.gl-empty p {
  margin: 0;
  max-width: 28rem;
  color: var(--text-secondary, #64748b);
  font-size: 0.95rem;
  line-height: 1.45;
}

.gl-board [hidden] {
  display: none !important;
}

@media (prefers-reduced-motion: no-preference) {
  .gl-lane {
    animation: gl-lane-in 0.45s var(--gl-ease) both;
  }

  .gl-lane:nth-child(2) { animation-delay: 0.05s; }
  .gl-lane:nth-child(3) { animation-delay: 0.1s; }
  .gl-lane:nth-child(4) { animation-delay: 0.15s; }
  .gl-lane:nth-child(5) { animation-delay: 0.2s; }
}

@keyframes gl-lane-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (max-width: 800px) {
  .gl-toolbar {
    position: static;
    background: transparent;
    backdrop-filter: none;
    padding: 0 0 0.85rem;
  }

  .gl-lane {
    grid-template-columns: 38px minmax(0, 1fr);
  }

  .gl-lane__main {
    padding: 0.9rem 0.95rem 0.35rem 0.85rem;
  }

  .gl-occupancy {
    grid-column: 2;
    justify-self: start;
    margin: 0 0.55rem 0.15rem;
  }

  .gl-lane__actions {
    grid-column: 2;
    justify-content: flex-end;
    padding: 0 0.65rem 0.7rem;
  }

  .gl-hero__add {
    width: 100%;
    justify-content: center;
  }

  .gl-court {
    width: 96px;
    height: 54px;
  }
}

@media (max-width: 480px) {
  .gl-board {
    padding-left: 0.85rem;
    padding-right: 0.85rem;
  }

  .gl-occupancy {
    width: 100%;
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Grouplist.css"],"names":[],"mappings":"AAEA,0EAA0E;AAC1E;EACE,wCAAwC;EACxC,sEAAsE;EACtE,qEAAqE;EACrE,kEAAkE;EAClE,0EAA0E;EAC1E,mGAAmG;EACnG,yCAAyC;EACzC,oEAAoE;EACpE,0DAA0D;;EAE1D,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd;;;;gDAI8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ;;8HAE4H;AAC9H;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,yCAAyC;EACzC,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yFAAyF;EACzF,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,0FAA0F;AAC5F;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,yEAAyE;EACzE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,6DAA6D;EAC7D,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,uEAAuE;EACvE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,8EAA8E;EAC9E,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,oDAAoD;EACpD,oBAAoB;EACpB,MAAM;EACN,mBAAmB;EACnB,iGAAiG;EACjG,sCAAsC;EACtC,gBAAgB;EAChB,wEAAwE;EACxE,yEAAyE;AAC3E;;AAEA;EACE;IACE,2BAA2B;IAC3B,wEAAwE;EAC1E;AACF;;AAEA,iBAAiB,sBAAsB,EAAE;AACzC,gBAAgB,qBAAqB,EAAE;AACvC,iBAAiB,sBAAsB,EAAE;AACzC,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,wBAAwB,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,oEAAoE;AACtE;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kEAAkE;EAClE,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sEAAsE;EACtE,0BAA0B;EAC1B,iBAAiB;EACjB;;kEAEgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;kBAEgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B;;;;GAIC;EACD,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD,qEAAqE;AACvE;;AAEA;EACE,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA,cAAc,SAAS,EAAE,QAAQ,EAAE;AACnC,cAAc,SAAS,EAAE,QAAQ,EAAE;AACnC,cAAc,SAAS,EAAE,QAAQ,EAAE;AACnC,cAAc,SAAS,EAAE,QAAQ,EAAE;AACnC,cAAc,SAAS,EAAE,WAAW,EAAE;AACtC,cAAc,SAAS,EAAE,WAAW,EAAE;AACtC,cAAc,SAAS,EAAE,WAAW,EAAE;AACtC,cAAc,SAAS,EAAE,WAAW,EAAE;;AAEtC;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,iEAAiE;EACjE,wBAAwB;AAC1B;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,uFAAuF;EACvF;;8BAE4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA,wBAAwB,sBAAsB,EAAE;EAChD,wBAAwB,qBAAqB,EAAE;EAC/C,wBAAwB,sBAAsB,EAAE;EAChD,wBAAwB,qBAAqB,EAAE;AACjD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap\");\n\n/* Hall groups — each squad is a court lane painted in the club colours. */\n.gl-board {\n  --gl-pine: var(--brand-primary, #0877bc);\n  --gl-tape: color-mix(in srgb, #fff 88%, var(--brand-primary, #0877bc));\n  --gl-clay: var(--brand-secondary, var(--brand-primary-dark, #0a5a8a));\n  --gl-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));\n  --gl-slate: color-mix(in srgb, var(--brand-primary, #0877bc) 42%, #1e293b);\n  --gl-lagoon: color-mix(in srgb, var(--brand-secondary, var(--brand-primary, #0877bc)) 72%, #0f766e);\n  --gl-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --gl-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --gl-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n\n  position: relative;\n  isolation: isolate;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding:\n    max(0.85rem, env(safe-area-inset-top, 0px))\n    max(1.15rem, env(safe-area-inset-right, 0px))\n    calc(2rem + env(safe-area-inset-bottom, 0px))\n    max(1.15rem, env(safe-area-inset-left, 0px));\n  overflow-x: clip;\n  overflow-y: auto;\n  max-height: calc(100vh - 64px);\n  color: var(--text-color);\n  font-family: var(--gl-body);\n}\n\n.gl-board--embedded {\n  padding: 0 0.25rem 0.5rem;\n  max-height: none;\n  overflow: visible;\n}\n\n.gl-board *,\n.gl-board *::before,\n.gl-board *::after {\n  box-sizing: border-box;\n}\n\n.gl-board .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.gl-board__glow {\n  pointer-events: none;\n  position: absolute;\n  z-index: -1;\n  inset: -8% -18% auto;\n  height: 180px;\n  opacity: 0.7;\n  background:\n    radial-gradient(52% 70% at 8% 18%, color-mix(in srgb, var(--gl-pine) 18%, transparent) 0%, transparent 72%),\n    radial-gradient(40% 55% at 92% 0%, color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent) 0%, transparent 68%);\n}\n\n.gl-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem 1.25rem;\n  margin-bottom: 1.15rem;\n}\n\n.gl-hero__copy {\n  min-width: 0;\n  max-width: 40rem;\n}\n\n.gl-hero__club {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  margin: 0 0 0.4rem;\n}\n\n.gl-hero__club img {\n  width: auto;\n  max-width: 36px;\n  max-height: 40px;\n  height: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.gl-hero__kicker {\n  display: block;\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.gl-hero__title {\n  margin: 0;\n  font-family: var(--gl-display);\n  font-size: clamp(2rem, 4.2vw, 2.85rem);\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  line-height: 0.95;\n  text-transform: uppercase;\n  color: var(--text-color);\n}\n\n.gl-hero__lede {\n  margin: 0.45rem 0 0;\n  max-width: 34rem;\n  font-size: 0.95rem;\n  line-height: 1.45;\n  color: var(--text-secondary, #64748b);\n}\n\n.gl-hero__add {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-shrink: 0;\n  padding: 0.7rem 1.05rem;\n  border-radius: 999px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-family: var(--gl-body);\n  font-size: 0.9rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n  transition: transform 0.18s var(--gl-ease), box-shadow 0.18s var(--gl-ease);\n}\n\n.gl-hero__add:hover {\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 10px 24px color-mix(in srgb, var(--brand-primary, #0877bc) 36%, transparent);\n}\n\n.gl-hero__add:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n}\n\n.gl-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem 1rem;\n  margin-bottom: 1.1rem;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 0.35rem 0 0.55rem;\n  background: color-mix(in srgb, var(--bg-color, #f7f8f6) 88%, transparent);\n  backdrop-filter: blur(10px);\n}\n\n.gl-toolbar__hint {\n  flex: 1 1 100%;\n  margin: -0.15rem 0 0;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.75rem;\n}\n\n.gl-search {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  flex: 1 1 16rem;\n  min-width: 0;\n  padding: 0.55rem 0.85rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.12));\n  background: var(--surface-color, #fff);\n  color: var(--text-secondary, #64748b);\n}\n\n.gl-search:focus-within {\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n  color: var(--text-color);\n}\n\n.gl-search input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-color);\n  font-family: inherit;\n  font-size: 0.92rem;\n}\n\n.gl-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.gl-pill {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.35rem;\n  padding: 0.38rem 0.7rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--gl-pine) 10%, var(--surface-color, #fff));\n  color: var(--text-color);\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n.gl-pill strong {\n  font-variant-numeric: tabular-nums;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n}\n\n.gl-lanes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.gl-lane {\n  --lane: var(--gl-pine);\n  display: grid;\n  grid-template-columns: 46px minmax(0, 1fr) auto auto;\n  align-items: stretch;\n  gap: 0;\n  border-radius: 18px;\n  border: 1px solid color-mix(in srgb, var(--lane) 22%, var(--border-color, rgba(15, 23, 42, 0.1)));\n  background: var(--surface-color, #fff);\n  overflow: hidden;\n  box-shadow: 0 12px 32px color-mix(in srgb, var(--lane) 10%, transparent);\n  transition: transform 0.2s var(--gl-ease), box-shadow 0.2s var(--gl-ease);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .gl-lane:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 16px 36px color-mix(in srgb, var(--lane) 16%, transparent);\n  }\n}\n\n.gl-lane--pine { --lane: var(--gl-pine); }\n.gl-lane--ink { --lane: var(--gl-ink); }\n.gl-lane--clay { --lane: var(--gl-clay); }\n.gl-lane--slate { --lane: var(--gl-slate); }\n.gl-lane--lagoon { --lane: var(--gl-lagoon); }\n\n.gl-lane__tape {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background: var(--lane);\n  box-shadow: inset -1px 0 0 color-mix(in srgb, #fff 16%, transparent);\n}\n\n.gl-lane__no {\n  font-family: var(--gl-display);\n  font-size: 1.55rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  line-height: 1;\n  color: var(--gl-tape);\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  text-shadow: 0 1px 0 color-mix(in srgb, #000 28%, transparent);\n}\n\n.gl-lane__main {\n  min-width: 0;\n  padding: 0.95rem 0.5rem 0.95rem 1rem;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  font: inherit;\n  cursor: default;\n}\n\n.gl-lane__main.is-open {\n  cursor: pointer;\n}\n\n.gl-lane__main.is-open:hover {\n  background: color-mix(in srgb, var(--lane) 6%, transparent);\n}\n\n.gl-lane__main:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: -2px;\n}\n\n.gl-lane__who {\n  min-width: 0;\n}\n\n.gl-lane__name-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.45rem 0.7rem;\n}\n\n.gl-lane__name {\n  margin: 0;\n  font-family: var(--gl-display);\n  font-size: clamp(1.35rem, 2.4vw, 1.7rem);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 1;\n  text-transform: uppercase;\n  color: var(--text-color);\n}\n\n.gl-lane__mode {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.12rem 0.48rem;\n  border-radius: 4px;\n  border: 1px solid color-mix(in srgb, var(--lane) 35%, transparent);\n  background: color-mix(in srgb, var(--lane) 9%, transparent);\n  color: var(--lane);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.gl-lane__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.85rem;\n  margin-top: 0.5rem;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.8rem;\n}\n\n.gl-lane__meta span {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.28rem;\n}\n\n.gl-lane__meta strong {\n  font-variant-numeric: tabular-nums;\n  font-weight: 650;\n  color: var(--text-color);\n}\n\n.gl-occupancy {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin: 0.55rem 0.15rem;\n  padding: 0.35rem 0.55rem;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: inherit;\n  font-family: var(--gl-body);\n  font-size: inherit;\n  cursor: pointer;\n}\n\n.gl-occupancy:hover {\n  background: color-mix(in srgb, var(--lane) 8%, transparent);\n}\n\n.gl-occupancy:hover .gl-occupancy__n {\n  color: var(--brand-primary, #0877bc);\n}\n\n.gl-occupancy:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.gl-court {\n  position: relative;\n  width: 124px;\n  height: 70px;\n  flex-shrink: 0;\n  margin: 6px 0;\n  border-radius: 3px;\n  border: 2.5px solid color-mix(in srgb, #f4f7f2 82%, var(--text-color));\n  background: var(--gl-pine);\n  overflow: visible;\n  box-shadow:\n    inset 0 0 0 1px color-mix(in srgb, #fff 22%, transparent),\n    0 6px 14px color-mix(in srgb, var(--gl-pine) 28%, transparent);\n}\n\n.gl-court__surface {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(90deg, color-mix(in srgb, #0b1f18 22%, transparent), transparent 18% 82%, color-mix(in srgb, #0b1f18 22%, transparent)),\n    var(--gl-pine);\n}\n\n.gl-court__net {\n  position: absolute;\n  left: 50%;\n  top: 2px;\n  bottom: 2px;\n  width: 3px;\n  transform: translateX(-50%);\n  background: repeating-linear-gradient(\n    180deg,\n    #f8faf8 0 3px,\n    transparent 3px 6px\n  );\n  opacity: 0.92;\n}\n\n.gl-court__mid {\n  position: absolute;\n  left: 7px;\n  right: 7px;\n  top: 50%;\n  height: 1.5px;\n  background: color-mix(in srgb, #fff 68%, transparent);\n}\n\n.gl-seat {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: color-mix(in srgb, #fff 22%, transparent);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, #fff 18%, transparent);\n}\n\n.gl-seat.is-on {\n  background: #f3efe4;\n  box-shadow: 0 0 0 1px color-mix(in srgb, #1a1208 35%, transparent);\n}\n\n.gl-seat--0 { left: 14%; top: 4px; }\n.gl-seat--1 { left: 34%; top: 4px; }\n.gl-seat--2 { left: 54%; top: 4px; }\n.gl-seat--3 { left: 74%; top: 4px; }\n.gl-seat--4 { left: 14%; bottom: 4px; }\n.gl-seat--5 { left: 34%; bottom: 4px; }\n.gl-seat--6 { left: 54%; bottom: 4px; }\n.gl-seat--7 { left: 74%; bottom: 4px; }\n\n.gl-occupancy__stat {\n  display: flex;\n  flex-direction: column;\n  min-width: 4.5rem;\n}\n\n.gl-occupancy__n {\n  font-variant-numeric: tabular-nums;\n  font-size: 1.45rem;\n  font-weight: 650;\n  letter-spacing: -0.04em;\n  line-height: 1;\n  color: var(--text-color);\n}\n\n.gl-occupancy__label {\n  margin-top: 0.15rem;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.gl-lane__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  padding: 0.65rem 0.7rem 0.65rem 0;\n  background: transparent;\n}\n\n.gl-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-secondary, #64748b);\n  cursor: pointer;\n  transition: background 0.15s var(--gl-ease), color 0.15s var(--gl-ease);\n}\n\n.gl-icon:hover {\n  background: color-mix(in srgb, var(--text-color) 7%, transparent);\n  color: var(--text-color);\n}\n\n.gl-icon--danger:hover {\n  background: color-mix(in srgb, #dc2626 12%, transparent);\n  color: #dc2626;\n}\n\n.gl-icon:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.gl-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1.6rem 1.2rem 1.5rem;\n  border-radius: 16px;\n  border: 1px dashed color-mix(in srgb, var(--gl-pine) 35%, var(--border-color, #d1d5db));\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--gl-pine) 6%, transparent), transparent 48%),\n    var(--surface-color, #fff);\n}\n\n.gl-empty__court {\n  width: 88px;\n  height: 50px;\n}\n\n.gl-empty p {\n  margin: 0;\n  max-width: 28rem;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.gl-board [hidden] {\n  display: none !important;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .gl-lane {\n    animation: gl-lane-in 0.45s var(--gl-ease) both;\n  }\n\n  .gl-lane:nth-child(2) { animation-delay: 0.05s; }\n  .gl-lane:nth-child(3) { animation-delay: 0.1s; }\n  .gl-lane:nth-child(4) { animation-delay: 0.15s; }\n  .gl-lane:nth-child(5) { animation-delay: 0.2s; }\n}\n\n@keyframes gl-lane-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (max-width: 800px) {\n  .gl-toolbar {\n    position: static;\n    background: transparent;\n    backdrop-filter: none;\n    padding: 0 0 0.85rem;\n  }\n\n  .gl-lane {\n    grid-template-columns: 38px minmax(0, 1fr);\n  }\n\n  .gl-lane__main {\n    padding: 0.9rem 0.95rem 0.35rem 0.85rem;\n  }\n\n  .gl-occupancy {\n    grid-column: 2;\n    justify-self: start;\n    margin: 0 0.55rem 0.15rem;\n  }\n\n  .gl-lane__actions {\n    grid-column: 2;\n    justify-content: flex-end;\n    padding: 0 0.65rem 0.7rem;\n  }\n\n  .gl-hero__add {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .gl-court {\n    width: 96px;\n    height: 54px;\n  }\n}\n\n@media (max-width: 480px) {\n  .gl-board {\n    padding-left: 0.85rem;\n    padding-right: 0.85rem;\n  }\n\n  .gl-occupancy {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
